import React, { createContext, useContext, useState, useEffect } from 'react';

interface AnimationContextType {
  disableAnimations: boolean;
}

const AnimationContext = createContext<AnimationContextType>({ disableAnimations: false });

export const AnimationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [disableAnimations, setDisableAnimations] = useState(false);

  useEffect(() => {
    // Disable animations after initial load to prevent them on route changes
    const timer = setTimeout(() => setDisableAnimations(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimationContext.Provider value={{ disableAnimations }}>
      {children}
    </AnimationContext.Provider>
  );
};

export const useAnimation = () => useContext(AnimationContext);